import { Layout } from "lucide-react";
import { LockedSection } from "@/components/plan/common";

export default function LandingSection({ landing, locked }) {
  if (!landing) return null;
  return (
    <LockedSection locked={locked} icon={Layout} title="Landing page copy">
      <div className="bg-white border border-zinc-200 rounded-2xl p-8">
        <div className="text-xs uppercase tracking-widest text-zinc-500">Hero</div>
        <h3 className="font-display font-black text-3xl md:text-4xl mt-2">{landing.hero_headline}</h3>
        <p className="text-zinc-600 mt-2">{landing.hero_subheadline}</p>
        <div className="mt-4 inline-block bg-indigo-600 text-white rounded-full px-5 py-2 text-sm">{landing.primary_cta}</div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <div>
            <div className="text-xs uppercase tracking-widest text-zinc-500">Value props</div>
            <ul className="mt-2 space-y-2 text-sm text-zinc-800">
              {landing.value_props?.map((v, i) => <li key={`vp-${i}-${v}`}>• {v}</li>)}
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest text-zinc-500">Trust signals</div>
            <ul className="mt-2 space-y-2 text-sm text-zinc-800">
              {landing.trust_signals?.map((v, i) => <li key={`ts-${i}-${v}`}>• {v}</li>)}
            </ul>
          </div>
        </div>

        {landing.faq?.length > 0 && (
          <div className="mt-8">
            <div className="text-xs uppercase tracking-widest text-zinc-500">FAQ</div>
            <div className="mt-2 space-y-3">
              {landing.faq.map((f, i) => (
                <div key={`faq-${i}-${(f.q || "").slice(0, 24)}`} className="border-t border-zinc-100 pt-3">
                  <div className="font-medium">{f.q}</div>
                  <div className="text-sm text-zinc-600 mt-1">{f.a}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </LockedSection>
  );
}
